module.exports = __webpack_public_path__ + "img/setting.513d6301.svg";